import { useMutation, useQueryClient } from "@tanstack/react-query";

import { serviceTemplateService } from "../../../services/serviceTemplatesService";
import type { ServiceTemplate } from "../../../types";

export const useCreateServiceTemplate = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (input: {
      name: string;
      description: string;
      type: ServiceTemplate["type"];
      kpiIds: string[];
    }) => serviceTemplateService.create(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["service-templates"] });
    },
  });
};
